import { Modal } from 'reactstrap';

const AccountLockedModal = () => {
  return (
    <Modal isOpen className="modal-lg" centered>
      <div className="d-flex justify-content-center align-items-center text-center">
        <p className="alert alert-danger mt-4 text-gray-600">Account locked. Please contact support.</p>
      </div>
    </Modal>
  );
};

export default AccountLockedModal;
